export enum PlatForm {
    MediaCorp = 'Mediacorp',
    Console = 'Console'
}